import { css, SerializedStyles } from '@emotion/react';

import tokens from '@vaad1st/shared.design-tokens/json/variables.json';

export const StyledScrollbars = css`
	&::-webkit-scrollbar {
		width: ${tokens.spacing_4px.value}px;
		position: absolute;
	}

	&::-webkit-scrollbar-track {
		background: ${tokens.color_light_background_neutral_tertiary};
	}

	&::-webkit-scrollbar-thumb {
		background: ${tokens.color_light_text_neutral_secondary};

		&:hover {
			background: ${tokens.color_light_text_neutral_primary};
		}
	}
`;

export const NoGapSupport = (styles: () => SerializedStyles) => css`
	@supports (-webkit-touch-callout: none) and (not (translate: none)) {
		${styles()}
	}
`;
